import { useDispatch, useSelector } from 'react-redux';

/**
 * Custom hooks for Redux store access
 *
 * These hooks provide a cleaner API and can be extended with
 * additional functionality like logging or analytics if needed.
 *
 * Usage in components:
 *   import { useAppDispatch, useAppSelector } from '@/app/hooks';
 *
 *   const dispatch = useAppDispatch();
 *   const user = useAppSelector(state => state.auth.user);
 */

// Use throughout the app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch();

// Use throughout the app instead of plain `useSelector`
export const useAppSelector = useSelector;
